module.exports = __webpack_public_path__ + "static/img/index_reg.d050df4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index_reg.jpg
// module id = Go2c
// module chunks = 1